import { render, staticRenderFns } from "./indexMobile.vue?vue&type=template&id=3b6c8feb&scoped=true"
import script from "./indexMobile.vue?vue&type=script&lang=js"
export * from "./indexMobile.vue?vue&type=script&lang=js"
import style0 from "./indexMobile.vue?vue&type=style&index=0&id=3b6c8feb&prod&lang=less&scoped=true"
import style1 from "./indexMobile.vue?vue&type=style&index=1&id=3b6c8feb&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3b6c8feb",
  null
  
)

export default component.exports